<template>
	<div class="comp">
		<el-dialog :title="'顾客信息'" :visible.sync="dialogGoodsListState" width="1500px">
			<el-form :inline="true" class="demo-form-inline" ref="form">
				<el-row>
					<el-col :span="8" >
						<el-form-item label="姓名：" :label-width="formLabelWidth">
							<div>{{detail.basic_info.nick_name}}</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="手机：" prop="user_mobile" :label-width="formLabelWidth">
							<div>{{detail.basic_info.user_mobile}}</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="性别：" :label-width="formLabelWidth">
							<div>{{detail.basic_info.sex}}</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="类型：" :label-width="formLabelWidth">
							{{detail.basic_info.user_type==0?'普通会员':'充值会员'}}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="生日：" :label-width="formLabelWidth">
							<div>{{detail.basic_info.birthday}}</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="住址：" :label-width="formLabelWidth">
							<div>{{detail.basic_info.home_address}}</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="余额：" :label-width="formLabelWidth">
							{{detail.card_info.user_yue}}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="赠额：" :label-width="formLabelWidth">
							<div>{{detail.card_info.user_zenge}}</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="line-height: 30px;padding-top:20px;">宠物信息</div>
			<el-table class="table" :data="detail.pets_info" style="width: 100%;">
				<el-table-column prop="nick_name" label="昵称" >
				</el-table-column>
				<el-table-column prop="sex" label="性别">
				</el-table-column>
				<el-table-column prop="class_name" label="类型">
				</el-table-column>
				<el-table-column prop="type_name" label="品种" >
				</el-table-column>
				<el-table-column prop="tool_num" label="用具" >
				</el-table-column>
				<el-table-column label="花生宠物" >
					<template slot-scope="scope">
						{{scope.row.hs_pet?'是':'否'}}
					</template>
				</el-table-column>
				<el-table-column prop="color" label="毛色">
				</el-table-column>
				<el-table-column prop="birth_day" label="生日">
				</el-table-column>
			</el-table>
			<div style="line-height: 30px;padding-top:20px;">消费卡信息</div>
			<el-table class="table" :data="cardsList" style="width: 100%;">
				<el-table-column prop="name" label="消费卡名称" width="300">
				</el-table-column>
				<el-table-column label="消费卡类型" width="120">
					<template slot-scope="scope">
						{{scope.row.card_type==1?'洗澡卡':''}}
						{{scope.row.card_type==2?'医疗套餐卡':''}}
					</template>
				</el-table-column>
				<el-table-column prop="card_number" label="消费卡号" width="150">
				</el-table-column>
				<el-table-column prop="sku_value" label="规格" width="150">
				</el-table-column>
				<el-table-column prop="service_name"  label="服务" width="250">
				</el-table-column>
				<el-table-column prop="consume_count" label="剩余次数" width="100">
				</el-table-column>
				<el-table-column prop="name" label="最近使用日期" >
					<template slot-scope="scope">
						{{scope.row.userTime?$public.FTime(scope.row.userTime):''}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="截止日期" >
					<template slot-scope="scope">
						{{$public.FTime(scope.row.exprice_time)}}
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogGoodsListState:true,
				detail:{
					basic_info:{},
					card_info:{},
					pets_info:[]
				},
				cardsList:[],
				formLabelWidth:'100px'
			}
		},
		props:{
			userId:{
				default:''
			}
		},
		watch:{
			dialogGoodsListState(n){
				this.$emit('close',n)
			}
		},
		mounted() {
			this.getUserDetail();
			this.getCardsList();
		},
		methods: {
			getUserDetail(){
				let params = {
					"id": this.userId,
				}
				this.$http.get('/api/Member/Single', params).then(res => {
					if(res.code==0){
						this.detail = res.data;
						// this.getUserOrderList(res.data._id);
						// this.getUserOrderRechargeList(res.data._id);
						// this.getDeposit(res.data._id)
					}
				})
			},
			getCardsList(){
				this.$http.get('/api/Member/BindCards', {
					memberId:this.userId,  
				}).then(res => {
					if (res.code == 0) {
						this.cardsList = res.data||[];
						for(let i=0;i<this.cardsList.length;i++){
							let list = this.cardsList[i].consume_record||[];
							if(list.length){
								list.sort(function(a, b){return Number(b.create_time) - Number(a.create_time)})
								this.cardsList[i].userTime=list[0].create_time;
							}
						}
					}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		::v-deep .el-dialog__body {
			padding-top: 0;
		}

		.dialog {

		}
	}
</style>
